import { ReportContext, StandardReportRow } from '../../report.models';
import { toEnglishDigits } from '../../report.utils';

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export function buildSearchIndex(row: StandardReportRow): string {
  return toEnglishDigits(Object.values(row).join('\n')).toLowerCase();
}

export function sumReportField(rows: StandardReportRow[], field: keyof StandardReportRow): number {
  const sum = rows.reduce((total, row) => total + (Number(row[field]) || 0), 0);
  return Math.round((sum + Number.EPSILON) * 100) / 100;
}

export function formatReportMinutes(minutes: number): string {
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}

export function buildStandardReportExport(context: ReportContext, filteredRows: StandardReportRow[]) {
  let headers: string[];
  let rows: (string | number)[][];
  const count = `تعداد کل: ${filteredRows.length}`;
  switch (context.id) {
    case '1':
      headers = ['#', 'نام متحرک', 'شماره پرسنلی', 'مسافت (km)', 'محدوده تاریخ'];
      rows = filteredRows.map((row, index) => [index + 1, row.strFullName ?? '', row.strPersonnelID ?? '',
        row.fDistance ?? '', `${context.endDate} - ${context.startDate}`]);
      rows.push([count, '', '', `${sumReportField(filteredRows, 'fDistance')} کیلومتر`, '']);
      break;
    case '2':
      headers = ['#', 'شماره پرسنلی', 'نام متحرک', 'مسافت (km)', 'مدت کارکرد', 'L/h', 'سوخت مصرفی (litre)'];
      rows = filteredRows.map((row, index) => [index + 1, row.strPersonnelID ?? '', row.strFullName ?? '',
        row.fDistance ?? '', row.strTotalDurationOperation ?? '', row.fConsumption ?? '', row.fGasPer100 ?? '']);
      rows.push([count, '', '', '', '', '', `${sumReportField(filteredRows, 'fGasPer100')} لیتر`]);
      break;
    case '3':
      headers = ['#', 'نام متحرک', 'شماره پرسنلی', 'زمان کل', 'زمان حرکت', 'زمان توقف'];
      rows = filteredRows.map((row, index) => [index + 1, row.strFullName ?? '', row.strPersonnelID ?? '',
        row.strFunction ?? '', row.strAbsoulatFunction ?? '', row.strParkTime ?? '']);
      rows.push([count, '', '', '', '', '']);
      break;
    default:
      return null;
  }
  return { headers, rows };
}
